import {Component, OnInit} from '@angular/core';
import {LoaderService} from '@core/src/public-api';
import {FaqItem} from '@shared/models/faq.model';
import {LoginService} from '@shared/services/login.service';

@Component({
  selector: 'si-faq-page',
  templateUrl: './faq-page.component.html',
  styleUrls: ['./faq-page.component.scss']
})
export class FaqPageComponent implements OnInit {
  items: FaqItem[];

  constructor(
    private loginService: LoginService,
    private loaderService: LoaderService
  ) { }

  ngOnInit(): void {
    const session = this.loginService.getSession();
    if (!session) {
      this.getFAQsUnlogged();
    } else {
      this.getFAQs();
    }
  }

  async getFAQsUnlogged(): Promise<void> {
    this.loaderService.start();
    try {
      this.items = await this.loginService.getFAQsUnlogged();
    } finally {
      this.loaderService.stop();
    }
  }

  async getFAQs(): Promise<void> {
    this.loaderService.start();
    try {
      this.items = await this.loginService.getFAQs();
    } finally {
      this.loaderService.stop();
    }
  }
}
